import { render, staticRenderFns } from "./Segmentos.vue?vue&type=template&id=19071f6e&scoped=true"
import script from "./Segmentos.vue?vue&type=script&lang=js"
export * from "./Segmentos.vue?vue&type=script&lang=js"
import style0 from "./Segmentos.vue?vue&type=style&index=0&id=19071f6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19071f6e",
  null
  
)

export default component.exports